export enum color {
  black = '#000',
  white = '#fff',
  lightGray = '#6d6e71',
  light = '#c8c9cb',
  sharpRed = '#e10008',
  darkZircon = '#474747',
  fireRed = '#b60c20',
  deepBlack = '#0e0e0e',
  smokyBlack = '#1d1d1d',
  coldBlue = '#036fe4',
  orange = '#ff5f00',
  greenHaze = '#009b3f',
  smoke = '#424242',
  newRedLight = '#FF002A',
  newRedDark = '#C8102E',
  newBlackLight = '#1D1D1D',
  newBlackDark = '#141414',
  newGreenLight = '#4CC620',
  newGreenDark = '#43AC1D',
  newGrayLight = '#484848',
  newGrayDark = '#343434',
  newBlueLight = '#2D9FE5',
  newOrangeLight = '#F77A20',
  newSmokeLight = '#7D7D7D',
  newSmokeDark = '#404040',
}

export enum Cursor {
  auto = 'auto',
  default = 'default',
  none = 'none',
  context = 'context',
  pointer = 'pointer',
  notallowed = 'not-allowed',
}
